import { UtilService } from "src/app/services/util.service"
import { PRI_ObtenerProfitMinimoRequest } from "../domain/tarifario-sli.request"
import { PricingRepository } from "../../services/pricing.repository"
import { Injectable } from "@angular/core"
import { MessageService } from "primeng/api"

@Injectable({
    providedIn: 'root'
})
export class BandejaTarifarioSliValidator {

    constructor(
        private readonly util: UtilService,
        private readonly servPricing: PricingRepository,
        private readonly servMessage: MessageService
    ) { }

    validateEndDate(option: any) {
        if (!option.row.ctar_vigentedesde) {
            this.servMessage.add({ summary: "Vigencia desde", detail: "Debe seleccionar una fecha de inicio.", severity: "warn" })
            option.row.ctar_vigentehasta = null

            if (option.datePicker) {
                option.datePicker.writeValue(null);
            }
        } else {
            if (option.row.ctar_vigentehasta < option.row.ctar_vigentedesde) {
                this.servMessage.add({ summary: "Vigencia hasta", detail: "Debe seleccionar una fecha mayor a la de inicio.", severity: "warn" })

                option.row.ctar_vigentehasta = null

                if (option.datePicker) {
                    option.datePicker.writeValue(null);
                }
            }
        }
    }

    validateInitDate(option: any) {
        if (!option.row.ctar_vigentedesde) {
            this.servMessage.add({ summary: "Vigencia desde", detail: "Debe seleccionar una fecha de inicio.", severity: "warn" })
            option.row.ctar_vigentehasta = null

            if (option.datePicker) {
                option.datePicker.writeValue(null);
            }
        } else {
            if (option.row.ctar_vigentehasta < option.row.ctar_vigentedesde) {
                this.servMessage.add({ summary: "Vigencia hasta", detail: "Debe seleccionar una fecha mayor a la de inicio.", severity: "warn" })

                option.row.ctar_vigentehasta = null

                if (option.datePicker) {
                    option.datePicker.writeValue(null);
                }
            }
        }
    }

    calculateCosto(row: any, tipo_cambio: { compra: number, venta: number }, tipo_tariff: string): void {

        const costoRaw = row["15_value"] ?? "0"
        const profitRaw = row["23_value"] ?? "0"
        const profitMinimoRaw = row["profit_minimo"] ?? null

        let costo: number = parseFloat(costoRaw)
        let profit: number = parseFloat(profitRaw)
        let profitMinimo: number = (profitMinimoRaw === null ? null : parseFloat(profitMinimoRaw))

        if (row['tipo_profit'] === '002') {
            profitMinimo = (costo * profitMinimo) / 100
        }

        if (row['moneda'] === '001') {
            profitMinimo = profitMinimo / tipo_cambio.venta
        }

        if (row["15_tipomoneda"] === '001') {
            costo = costo / tipo_cambio.venta;
        }

        if (row["23_tipomoneda"] === '001') {
            profit = profit / tipo_cambio.venta;
        }

        const ventaTotal = costo + profit;

        // if (profitMinimo === null) {
        //     this.util.ShowMessage({ mensaje: "El servicio seleccionado no cuenta con profit minimo.", tipo: "warning" })
        //     row["16_value"] = 0
        //     row["23_value"] = 0
        //     return
        // }

        // if (profit < profitMinimo) {
        //     this.util.ShowMessage({ mensaje: "No se puede ingresar un monto menor al profit minimo: " + profitMinimo.toFixed(2).toString() + ' USD.', tipo: "warning" })
        //     row["16_value"] = 0
        //     row["23_value"] = 0
        //     return
        // }

        if (ventaTotal < 0) {
            this.util.ShowMessage({ mensaje: "No se puede ingresar una venta negativa", tipo: "warning" })
            row["16_value"] = costo;
            row["23_value"] = 0;
            return
        }

        if (tipo_tariff === '004' && row["37_codigointerno"] === "001") {
            row["16_value"] = ventaTotal
        } else {
            row["16_value"] = ventaTotal
        }

        // if (ventaTotal < costo) {
        //     this.util.ShowMessage({ mensaje: "No se puede ingresar un monto menor al costo", tipo: "warning" })
        //     row["16_value"] = 0
        //     row["23_value"] = 0
        // } else {
        //     row["16_value"] = ventaTotal.toFixed(0)
        // }

        //  row["16_tipomoneda"] = '002'
        if (row["15_tipomoneda"] == '004') {
            row["16_tipomoneda"] = '004'
        } else {

            row["16_tipomoneda"] = '002'
        }

    }

    validateCosto(row: any, tipo_cambio: { compra: number, venta: number }, tipo_tariff: string): void {

        const costoRaw = row["15_value"] ?? "0";
        const profitRaw = row["23_value"] ?? "0";
        const profitMinimoRaw = row["profit_minimo"] ?? "0";

        let costo: number = parseFloat(costoRaw)
        let profit: number = parseFloat(profitRaw)

        if (row["15_tipomoneda"] === '001') {
            costo = costo / tipo_cambio.venta;
        }

        if (row["23_tipomoneda"] === '001') {
            profit = profit / tipo_cambio.venta;
        }

        if (profit === 0) {
            return
        }

        const ventaTotal = costo + profit
        if (tipo_tariff === '004' && row["37_codigointerno"] === "001") {
            row["16_value"] = ventaTotal
        } else {
            row["16_value"] = ventaTotal
        }

        if (row["15_tipomoneda"] == '004') {
            row["16_tipomoneda"] = '004'
        } else {

            row["16_tipomoneda"] = '002'
        }

    }

    validateServicio(row: any): void {

        const servicio = parseInt(row.children["3_codigointerno"])
        row.children.serv_codigo = servicio
        const request = <PRI_ObtenerProfitMinimoRequest>{}
        request.serv_codigo = servicio
        this.servPricing.PRI_ObtenerProfitMinimo(request).subscribe(response => {
            if (response.datos.status === 200) {
                row.children.serv_codigo = servicio
                row.children.profit_minimo = response.datos.result[0].monto
                row.children.tipo_profit = response.datos.result[0].tipo_Profit
                row.children.moneda = response.datos.result[0].tipo_codmnd
            }
        }, error => {
            // this.util.ShowMessage({ mensaje: "El servicio seleccionado no cuenta con profit minimo.", tipo: "warning" })
            // row.children["3_codigointerno"] = null
            // row.children["3_label"] = null
            // row.children.serv_codigo = null
            row.children.profit_minimo = null
            row.children.serv_codigo = servicio
        })

    }

}